export default "__VITE_ASSET__BfWDbDgr__"